import styled from 'styled-components';

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export const ReadOnlyField = styled.div.attrs({})`
  width: 100%;
  padding: 12px;
  margin: 8px 0 16px;
  border: 1px solid #e0e0e0;
  background-color: #f9f9f9;
  border-radius: 6px;
  font-size: 1em;
  color: #444;
  white-space: pre-wrap;
  overflow-y: auto;
`;

export const Label = styled.div.attrs({})`
  display: block;
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
  font-size: 0.95em;
`;

export const ActionButtonContainer = styled.div.attrs({
  CompanyButtonContainer,
})`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  justify-content: flex-end;
  gap: 10px;
`;
